export const truncateFileName = (name: string, maxLength: number) => {
  if (name.length <= maxLength) return name;
  const extension = name.slice(name.lastIndexOf("."));
  const truncatedName =
    name.slice(0, maxLength / 2) +
    "..." +
    name.slice(-maxLength / 2 + extension.length);
  return truncatedName;
};
